import { connect } from "react-redux";
import { ResultsComparisonCharts as Component } from "../ResultsComparisonCharts";

export function mapStateToProps(state, ownProps) {
  const { cscq } = state;

  // Create a new predictionData object instead of mutating the prop
  let predictionDataContent = [...(ownProps.predictionData.content.data || [])];
  let dependsOnComponentId = ownProps.predictionData.content.dependsOn;
  if (cscq[dependsOnComponentId] && cscq[dependsOnComponentId].disabled) {
    if (
      cscq[dependsOnComponentId].disabled[0] &&
      cscq[dependsOnComponentId].disabled[0] === 1
    ) {
      predictionDataContent = [
        { x: 2, y: 1 },
        { x: 7, y: 0.05 },
        { x: 12, y: 1 },
      ];
    } else if (
      cscq[dependsOnComponentId].disabled[0] &&
      cscq[dependsOnComponentId].disabled[0] === 2
    ) {
      predictionDataContent = [
        { x: 2, y: 0.05 },
        { x: 12, y: 1 },
      ];
    } else {
      predictionDataContent = [
        { x: 2, y: 0.05 },
        { x: 7, y: 1.0 },
        { x: 12, y: 0.05 },
      ];
    }
  }

  // Create a new predictionData object with the updated content
  const predictionData = {
    ...ownProps.predictionData,
    content: {
      ...ownProps.predictionData.content,
      data: predictionDataContent,
    },
  };

  // Process actualData without mutation
  const wellsColors = state["microplate"].wellsColors;
  const actualDataContent = Object.values(wellsColors)
    .filter(
      (wellsColor) =>
        wellsColor.description.includes("S + pH") &&
        wellsColor.description.includes("enzyme")
    )
    .map((wellsColor) => {
      const phValue = parseInt(wellsColor.description.match(/pH (\d+)/)[1], 10);
      return { x: phValue, y: parseFloat(wellsColor.average) };
    });

  // Create a new actualData object with the updated content
  const actualData = {
    ...ownProps.actualData,
    content: {
      ...ownProps.actualData.content,
      data: actualDataContent,
    },
  };

  return {
    ...ownProps,
    predictionData: predictionData,
    actualData: actualData,
  };
}

export const ResultsComparisonChartsRedux = connect(mapStateToProps)(Component);
